import $ from 'jquery';
import UI from 'root/ui';
import Cache from 'root/cache';
import Constants from 'root/constants';
import Modals from 'root/modals';
import View from 'view/base';
import Tooltip from 'root/module/tooltip';
import {showAutoReplyMessage, deleteComment} from 'service/feedback';

export default View.extend({
    className: 'feedback-viewer-actions',

    events: {
        'click .dropdown-workflow li' : 'changeWorkflow',
        'click .dropdown-assignee li' : 'changeUser',
        'click .resolve'              : 'resolveFeedback',
        'click button.share'          : 'shareFeedback',
        'click button.settings'       : 'openSettings',
        'click .integration-send'     : 'onSendToIntegration'
    },

    dom_handlers: {
        onSendToIntegration: function(e) {
            var integration_type = $(e.currentTarget).data('val');
            Modals.sendToIntegration(integration_type, this.model);
        },

        openDetails: function(e) {
            if (this.$el.find('.region-details-dropdown').is(':visible')) {
                this.$el.find('.region-details-dropdown').hide();
            } else {
                this.$el.find('.region-details-dropdown').show();
                this.views.details.loadHistory();
            }
        },

        shareFeedback: function(e) {
            Modals.shareFeedback(this.model);
        },

        openSettings: function(e) {
            Modals.editFeedback(this.model.id);
        },

        changeWorkflow: function(e) {
            const workflow_id = parseInt($(e.currentTarget).data('id'), 10);
            const type = $(e.currentTarget).data('type');

            if (!workflow_id) {
                return;
            }

            if (workflow_id === this.model.get('workflow')) {
                return;
            }

            const is_resolved = Cache.workflow.get(workflow_id).isResolved();

            Cache.app.request({
                action: 'feedback/setWorkflow',
                context: this,
                data: {
                    ids: [this.model.id],
                    workflow: workflow_id,
                    send_autoreply: is_resolved && type === 'resolve-reply'
                },
                success: function(result) {
                    if (!result || !result.autoreply_comments || result.autoreply_comments.length === 0) {
                        return;
                    }
                    const autoreply_comments = result.autoreply_comments;
                    const autoreply_comment_ids = result.autoreply_comments.map((comment) => comment.id);
                    showAutoReplyMessage(() => {
                        deleteComment(autoreply_comment_ids);
                    });

                    // Do something with the comments
                    autoreply_comments.forEach((autoreply_comment) => {
                        if (!Cache.feedback_comment.get(autoreply_comment.id)) {
                            Cache.feedback_comment.add(autoreply_comment);
                        }
                    });
                }
            });

            UI.success('Status updated');
            this.model.set({workflow: workflow_id});
        },

        resolveFeedback: function(e) {
            // filter out the workflow whose type is resolve-reply
            this.$el.find('.dropdown-workflow li[data-type="resolve"]:last').click();

            Tooltip.removeAll();
        },

        changeUser: function(e) {
            var user_id = parseInt($(e.currentTarget).data('id'), 10);

            if (isNaN(user_id)) {
                return;
            }

            if (user_id === this.model.get('user_id')) {
                return;
            }

            Cache.app.request({
                action: 'feedback/setUser',
                context: this,
                data: { ids: [this.model.id], user_id: user_id }
            });

            this.model.set({ user_id: user_id });

            if (user_id) {
                UI.success('Feedback assigned');
            } else {
                UI.success('Feedback unassigned');
            }
        }
    },

    initialize: function(options) {
        this.listenTo(this.model, 'change', this.render);
    },

    render: function() {
        var content = '';

        var is_merged_feedback = this.model.isMergedFeedback();

        if (!Cache.app.isClient()) {
            var assigned_user     = Cache.user.get(this.model.get('user_id'));
            var selected_workflow = Cache.workflow.get(this.model.get('workflow')) ? Cache.workflow.get(this.model.get('workflow')) : false;
            var workflow_name     = selected_workflow ? selected_workflow.escape('name') : '-';

            var workflow_options = '';
            var project_workflow = Cache.workflow.where({project_id: this.model.get('project_id')});
            const is_resolved = Cache.workflow.get(this.model.get('workflow')).isResolved();
            const feedback_autoreply = Cache.feedback_autoreply.findWhere({project_id: this.model.get('project_id')});

            var is_autoreply_enabled = feedback_autoreply?.isEnabled(this.model.get('feedback_type'));


            project_workflow.forEach((model, key) => {
                if (key === project_workflow.length - 1) {
                    workflow_options += '<li class="separator"></li>';
                }

                const is_workflow_resolved = model.isResolved();

                workflow_options += '<li data-id="' + model.id + '"' + (model.id === this.model.get('workflow') ? ' class="selected"' : '') + ' data-type="' + (is_workflow_resolved ? 'resolve' : 'default') + '">' +
                                        '<span class="workflow-option-colour" style="background-color:' + model.get('colour') + ';"></span>' +
                                        model.escape('name') +
                                    '</li>';

                if (key === project_workflow.length - 1 && !is_resolved && is_autoreply_enabled) {
                    workflow_options += '<li class="separator"></li>';

                    workflow_options += '<li class="notrim" data-id="' + model.id + '" data-type="resolve-reply" >' +
                                        '<span class="workflow-option-colour" style="background-color:' + model.get('colour') + ';"></span>' +
                                        model.escape('name') + ' & Auto-reply' +
                                    '</li>';
                }
            });

            var user_options = '<li data-id="0"' + (this.model.get('user_id') === 0 ? ' class="selected"' : '') + '>' +
                                    '<img class="user-img" src="/image/profile.png">' +
                                    'Unassigned' +
                               '</li>';
            var users = Cache.app.getUsersByProject(this.model.get('project_id'), [Constants.ADMIN, Constants.ASSIGNEE]);

            users.forEach((user) => {
                user_options += '<li data-id="' + user.id + '"' + (user.id === this.model.get('user_id') ? ' class="selected"' : '') + '>' +
                                    '<img class="user-img" src="' + user.getAvatar(24) + '">' +
                                    user.escape('name') +
                                '</li>';
            });

            var integration_options = [
                {
                    model: Cache.integration_jira.findWhere({project_id: this.model.get('project_id')}),
                    url_property: 'jira_url',
                    name: 'Jira',
                    logo: '/image/jira_small.png'
                },
                {
                    model: Cache.integration_clickup.findWhere({project_id: this.model.get('project_id')}),
                    url_property: 'clickup_url',
                    name: 'ClickUp',
                    logo: '/image/clickup_small.png'
                },
                {
                    model: Cache.integration_wrike.findWhere({project_id: this.model.get('project_id')}),
                    url_property: 'wrike_url',
                    name: 'Wrike',
                    logo: '/image/wrike_small.png'
                },
                {
                    model: Cache.integration_azure_devops.findWhere({project_id: this.model.get('project_id')}),
                    url_property: 'azure_devops_url',
                    name: 'Azure DevOps',
                    logo: '/image/azure_devops_small.png'
                },
                {
                    model: Cache.integration_teamwork.findWhere({project_id: this.model.get('project_id')}),
                    url_property: 'teamwork_url',
                    name: 'Teamwork',
                    logo: '/image/teamwork_small.png'
                },
                {
                    model: Cache.integration_trello.findWhere({project_id: this.model.get('project_id')}),
                    url_property: 'trello_url',
                    name: 'Trello',
                    logo: '/image/trello_small.png'
                },
                {
                    model: Cache.integration_basecamp.findWhere({project_id: this.model.get('project_id')}),
                    url_property: 'basecamp_url',
                    name: 'Basecamp',
                    logo: '/image/basecamp_small.png'
                },
                {
                    model: Cache.integration_asana.findWhere({project_id: this.model.get('project_id')}),
                    url_property: 'asana_url',
                    name: 'Asana',
                    logo: '/image/asana_small.png'
                },
                {
                    model: Cache.integration_monday.findWhere({project_id: this.model.get('project_id')}),
                    url_property: 'monday_url',
                    name: 'Monday',
                    logo: '/image/monday_small.png'
                },
                {
                    model: Cache.integration_zendesk.findWhere({project_id: this.model.get('project_id')}),
                    url_property: 'Zendesk',
                    name: 'zendesk',
                    logo: '/image/zendesk_small.png'
                },
                {
                    model: Cache.integration_github.findWhere({project_id: this.model.get('project_id')}),
                    url_property: 'github_url',
                    name: 'GitHub',
                    logo: '/image/github_small.png'
                },
                {
                    model: Cache.integration_gitlab.findWhere({project_id: this.model.get('project_id')}),
                    url_property: 'gitlab_url',
                    name: 'GitLab',
                    logo: '/image/gitlab_small.png'
                },
                {
                    model: Cache.integration_linear.findWhere({project_id: this.model.get('project_id')}),
                    url_property: 'linear_url',
                    name: 'Linear',
                    logo: '/image/linear_small.png'
                },
                {
                    model: Cache.integration_notion.findWhere({project_id: this.model.get('project_id')}),
                    url_property: 'notion_url',
                    name: 'Notion',
                    logo: '/image/notion_small.png'
                },
            ];

            var resolved_title = 'Set to ' + project_workflow[project_workflow.length - 1].escape('name');

            if (!is_merged_feedback) {
                integration_options.forEach((option) => {
                    if (option.model && option.model.isConnected()) {
                        var tooltip = '';
                        var is_processing = this.model.get(option.url_property) === 'processing';

                        if (this.model.get(option.url_property)) {
                            tooltip = is_processing ? 'Sending to ' + option.name : 'View in ' + option.name;
                        } else {
                            tooltip = 'Send to ' + option.name;
                        }

                        content +=
                        '<button data-val="' + option.name.replace(' ', '_').toLowerCase() + '" class="integration-send tertiary-text square small"' + (is_processing ? ' disabled' : '') + '>' +
                            '<img class="integration-icon" src="' + option.logo + '">' +
                            '<span>' + tooltip + '</span>' +
                        '</button>';
                    }
                });

                content +=
                '<div class="button-dropdown button-dropdown-full button-dropdown-assignee" data-append="true" data-trim="false">' +
                    '<button type="button" class="dropdown-select small">' +
                        (assigned_user ?  assigned_user.escape('name') : 'Unassigned') +
                    '</button>' +
                    '<div>' +
                        (users.length > 10 ?
                        '<div class="dropdown-search">' +
                            '<input type="text" class="solid compact" placeholder="Search user">' +
                        '</div>' : '') +
                        '<ul class="dropdown dropdown-select dropdown-assignee" data-empty="No users found">' +
                            user_options +
                        '</ui>' +
                    '</div>' +
                '</div>' +

                '<div class="button-dropdown button-dropdown-full" data-append="true" data-trim="false" data-offset="' + (is_resolved ? '' : '32,0') + '" resolved="' + (is_resolved ? 1 : 0) + '">' +
                    '<button type="button" class="dropdown-select small">' +
                        '<span class="workflow-option-colour" style="background-color:' + (selected_workflow ? selected_workflow.get('colour') : '') + ';"></span>' +
                        workflow_name +
                    '</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select dropdown-workflow">' +
                            workflow_options +
                        '</ul>' +
                    '</div>' +
                '</div>' +
                '<button type="button" class="tertiary small square resolve tooltip" data-title="' + resolved_title + '" data-position="down" data-offset="0,-10" resolved="' + (is_resolved ? 1 : 0) + '"><i class="fas fa-check-circle"></i></button>';
            }

            content +=
            '<button class="primary small share" type="button"><i class="fas fa-share"></i> Share</button>' +
            '<button class="text small settings"><i class="fas fa-cog"></i></button>';
        }

        this.$el.html(content);

        return this;
    }
});
